module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.c4668ed2.ttf";